import { useState } from "react";
import { Tabs, Button, Space, message, Row, Col, DatePicker, Card, List, Input, Select,Form,Typography } from "antd";
import { useDispatch } from "react-redux";
import PageBreadcrumb from "../../component/PageBreadcrumb";
import { uploadLearnerCSV } from "../../redux/actions/AuthAction";

const { TabPane } = Tabs;

const UploadCSVFile = () => {
    const [loader, setLoader] = useState(false);
    const [file, setFile] = useState(null);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    const handleUpload = () => {
        if (!file) {
            message.error('Please select a file before uploading.');
            return;
        }

        setLoader(true);
        
        const onSuccess = () => {
            setLoader(false);
            message.success('File uploaded successfully!');
        };

        const onError = (error) => {
            setLoader(false);
            message.error(`File upload failed: ${error.message}`);
        };

        const formData = new FormData();
        formData.append('file', file);

        uploadLearnerCSV(formData, onSuccess, onError);
    };

    return (

        
        <div>
            <PageBreadcrumb route={["dashboard", "Upload Learner CSV File"]} />

            <Tabs defaultActiveKey="1">
                <TabPane tab="Upload File" key="1">
                  
                    <Card title="Upload Bulk Learner Signup CSV File" style={{ marginBottom: "1rem" }}>
                        
                        <Form>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Form.Item
                                    name="upload"
                                    rules={[{ required: true, message: 'Please upload a file' }]}
                                    tooltip="This is a required field"
                                    style={{ flex: 0.85, marginRight: '16px' }}
                                >
                                    <Input type="file" onChange={handleFileChange} />
                                </Form.Item>
                                <Form.Item style={{ flex: 0.15 }}>
                                    <Button type="primary" onClick={handleUpload} loading={loader}>
                                        {loader ? "Uploading" : "Upload"}
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>
                        <span style={{ fontSize: "0.8rem" }}>
                        Note: The CSV file must include a column name <b>phoneNumber</b>.
                     </span>                
                    </Card>
                </TabPane>
            </Tabs>


        </div>

    );
};

export default UploadCSVFile;